export function isSubscribed (user) {
  return !!user?.expiredAt && isActiveSubscriptionDate(user.expiredAt)
}
function isActiveSubscriptionDate (date) {
  return new Date(date) - new Date() > 0
}